import { render, staticRenderFns } from "./headMenu.vue?vue&type=template&id=27a1c502&scoped=true&"
import script from "./headMenu.vue?vue&type=script&lang=js&"
export * from "./headMenu.vue?vue&type=script&lang=js&"
import style0 from "./headMenu.vue?vue&type=style&index=0&id=27a1c502&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a1c502",
  null
  
)

export default component.exports